module.exports = __webpack_public_path__ + "static/media/chess.4efacbd4.svg";